import { useMutation, useQueryClient } from "@tanstack/react-query"
import { respondToOffer } from "@/api"

export const useRespondToOffer = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ dealId, offerNumber, isAccepted }: { dealId: number, offerNumber: number, isAccepted: boolean }) =>
      respondToOffer({ dealId, offerNumber, isAccepted }),

    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["clientDeals"] });
    },
  })
}